<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		preserveAspectRatio="none"
		:viewBox="`0 0 ${baseWidth} ${baseHeight}`"
	>
		<defs>
			<clipPath id="clip-path">
				<path :d="path" />
			</clipPath>
		</defs>

		<!-- Заливка -->
		<path
			:d="path"
			:fill="fillColor"
		/>

		<!-- Stroke внутрь с помощью clip-path -->
		<path
			:d="path"
			:stroke="strokeColor"
			:stroke-width="strokeWidth * 2"
			fill="none"
			clip-path="url(#clip-path)"
		/>
	</svg>
</template>

<script setup>
	import { defineProps, computed } from 'vue'
	import { toNumber } from '@vue/shared'

	const props = defineProps({
		strokeWidth: {
			type: [Number, String],
			default: 2,
		},
		strokeColor: {
			type: String,
			default: 'black',
		},
		fillColor: {
			type: String,
			default: 'none',
		},
		path: {
			type: String,
			default: 'M399 1V99H36.3643L1.23047 50L36.3643 1H399Z',
		},
	})

	const baseWidth = 400
	const baseHeight = 100

	const strokeWidth = computed(() => toNumber(props.strokeWidth))
</script>

<style scoped>
	svg {
		width: 100%;
		height: 100%;
		display: block;
	}
</style>
